// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1QUaZ","insightsList":"newBusinessInsightsMenu_insightsList__3T4uC","active":"newBusinessInsightsMenu_active__3dqxH"};